import { useNavigate } from "react-router-dom";
import { useResearch } from "../../api/api-hooks";
import { createColumnHelper } from "@tanstack/react-table";
import { Loader } from "../../common/Loader";
import ReactTanstackTableUi from "../../common/ReactTanstackTableUi";
import { FaTrashAlt, FaEye } from "react-icons/fa";
import { formatDateTimeAndYear } from "../../utils/date-utils";

function prepareColumns(columnHelper: any, handleActions: any) {
  return [
    columnHelper.accessor((row: any) => row.researchListName, {
      id: "researchListName",
      cell: (info: any) => {
        const row = info.row;
        const original = row?.original;

        return (
          <div className=" flex flex-col gap-1">
            <div className="font-semibold text-gray-800 text-base truncate w-full max-w-xs">
              {original?.researchListName || "--"}
            </div>
          </div>
        );
      },
      header: () => <div>List Name</div>,
    }),
    columnHelper.accessor((row: any) => row.createdat, {
      id: "Created At",
      cell: (info: any) => {
        const row = info.row;
        const original = row?.original;

        return (
          <div className=" flex flex-col gap-1">
            <div className="font-semibold text-gray-800 text-base max-w-xs">
              {original?.timestamp
                ? (() => {
                    const { date, time } = formatDateTimeAndYear(
                      original.timestamp
                    );
                    return `${date} ${time}`;
                  })()
                : "--"}
            </div>
          </div>
        );
      },
      header: () => <div>Created At</div>,
    }),
    columnHelper.accessor((row: any) => row.createdby, {
      id: "Created By",
      cell: (info: any) => {
        // const row = info.row;
        // const original = row?.original;

        return (
          <div className=" flex flex-col gap-1">
            <div className="font-semibold text-gray-800 text-base max-w-xs">
              {/* {original?.timestamp || "--"} */}
            </div>
          </div>
        );
      },
      header: () => <div>Created By</div>,
    }),
    columnHelper.accessor((row: any) => row.actions, {
      id: "Actions",
      cell: (info: any) => {
        const row = info.row;
        const original = row?.original;

        return (
          <div className="flex items-center space-x-4">
            {/* View Icon */}
            <FaEye
              className="text-blue-500 cursor-pointer"
              onClick={() => handleActions("view", original?.research_id)}
              title="View"
            />

            {/* Delete Icon */}
            <FaTrashAlt
              className="text-red-500 cursor-pointer"
              onClick={() => handleActions("delete", original?.research_id)}
              title="Delete"
            />
          </div>
        );
      },
      header: () => <div>Actions</div>,
    }),
  ];
}

function ProjectListTable() {
  const {
    data: research,
    isLoading: isResearchLoading,
    // error: researchError,
  } = useResearch();

  const apiData = Array.isArray(research) ? research : [];
  const columnHelper = createColumnHelper();

  const columns = prepareColumns(columnHelper, handleActions);

  const navigate = useNavigate();

  //   const [selectedId, setSelectedId] = useState<string | null>(null);

  //   function handleView(fetchId: string) {}

  //   function handleFetch(fetchType: string, fetchId: string) {
  //     // setType(fetchType);
  //     setSelectedId(fetchId);
  //   }

  function handleActions(fetchType: string, fetchId: string) {
    if (!isResearchLoading && fetchType === "view") {
      navigate(`/research/${fetchId}/view`);
    }
    if (!isResearchLoading && fetchType === "delete") {
      // console.log("delete");
    }
  }

  if (isResearchLoading) {
    return <Loader />;
  }

  return (
    <div className="md:p-10 p-3">
      <ReactTanstackTableUi
        data={apiData}
        columns={columns}
        pagination={apiData?.length > 10}
        noDataMessage="Research"
        tableTitle="Research"
      />
    </div>
  );
}

function Research() {
  return (
    <div className=" flex flex-col gap-6 ">
      <div>
        <ProjectListTable />
      </div>
    </div>
  );
}

export default Research;
